export function resolveTermsModalScrollLayout(termsDocumentUrl, children, linkedTerms) {
    const showIframeFallback = termsDocumentUrl != null && children == null && linkedTerms.status === 'iframe';
    const showLinkedLoading = termsDocumentUrl != null && children == null && (linkedTerms.status === 'loading' || linkedTerms.status === 'idle');
    return { showIframeFallback, showLinkedLoading };
}
export function buildTermsScrollSectionClassName(parts) {
    const { scrollBox, scrollBoxNoInset, scrollBoxWithIframe, hasChildren, iframeFallback } = parts;
    return [scrollBox, !hasChildren ? scrollBoxNoInset : '', iframeFallback ? scrollBoxWithIframe : '']
        .filter(Boolean)
        .join(' ');
}
